'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        width: 100%;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        width: 100%;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  @media only screen and (min-width: 1098px) {\n    ", ";\n  }\n\n  @media only screen and (min-width: 1400px) {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container = _styledComponents2.default.div(_templateObject(), function (props) {
  return !props.isLanding && _styledComponents.css(_templateObject2());
}, function (props) {
  return !props.isLanding && _styledComponents.css(_templateObject3());
});

exports.default = {
  Container: Container
};